/**
 * Web presentation wrapper around zen-core-elements' ZenFilterModal.
 *
 * ZenFilterModal is a full-bleed sheet: its root is
 * `<SafeAreaView style={{flex: 1, backgroundColor: 'white'}}>` inside an RN
 * Modal, with no prop to constrain it. That reads correctly on a phone. On a
 * 1600px desktop the same sheet stretches edge to edge, so six filter rows
 * run the full width of the monitor with ~400px of empty space beneath them.
 *
 * The sheet itself stays full-bleed - changing that needs a change inside the
 * shared library, and it is what Android expects. What this wrapper does is
 * give the *content* the same desktop measure the rest of the app uses, via
 * the component's own public `containerStyle` prop, so the rows line up in a
 * readable column instead of spanning the display.
 *
 * Defaults go first, so any screen that already passes containerStyle wins.
 */

import React from 'react';
import {StyleSheet} from 'react-native';
import BaseZenFilterModal from 'zen-core-elements/src/elements/zenFilterModal/zenFilterModal';
import type {ZenFilterModalProps} from 'zen-core-elements/src/elements/zenFilterModal/zenFilterType.modal';

import {webModal} from './webTokens';

const styles = StyleSheet.create({
  content: {
    width: '100%',
    maxWidth: webModal.maxWidth,
    alignSelf: 'center',
  },
});

const WebZenFilterModal = ({containerStyle, ...props}: ZenFilterModalProps) => (
  <BaseZenFilterModal
    {...(props as ZenFilterModalProps)}
    containerStyle={[styles.content, containerStyle]}
  />
);

export default WebZenFilterModal;
